import script from "./GlobalGroupsSelectOption.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalGroupsSelectOption.vue?vue&type=script&setup=true&lang=js"

import "./GlobalGroupsSelectOption.vue?vue&type=style&index=0&id=3ed2996a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ed2996a"]])

export default __exports__